import {
  Box,
  Modal,
  Table,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { IActivity } from "./TemplateDataGovernance.types";
import { Close } from "@mui/icons-material";
import { formatDate } from "./TemplateDataGovernance.utils";

type IProps = {
  activities: IActivity[];
  isOpen: boolean;
  onClose: () => void;
};

export function TemplateDataGovernanceModal({
  activities,
  isOpen,
  onClose,
}: IProps) {
  return (
    <Modal
      open={isOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          height: "auto",
          width: "100%",
          maxWidth: 900,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "1rem",
          border: "none",
          outline: "none",
          padding: "24px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h6
            style={{
              padding: "0",
              margin: "0",
              fontSize: "1.25rem",
              lineHeight: "1.75rem",
              fontWeight: 600,
            }}
          >
            Atividades relacionadas
          </h6>
          <Close style={{ cursor: "pointer" }} onClick={onClose} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            marginBottom: "34px",
            marginTop: "24px",
          }}
        >
          <span
            style={{
              fontSize: "16px",
              lineHeight: "175%",
              fontWeight: "400",
              color: "#191C1A",
            }}
          >
            Para ter Governança de dados atualizada verifique se as atividades
            abaixo estão atualizadas de acordo com sua execução programada.
          </span>
        </div>
        <TableContainer
          sx={{
            "& .MuiTableCell-root": { background: "#FFFFFF !important" },
          }}
        >
          <Table>
            <TableRow style={{ height: "70px" }}>
              <TableCell>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "rgb(111, 111, 120)",
                    fontWeight: "400",
                  }}
                >
                  Nome
                </span>
              </TableCell>
              <TableCell>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "rgb(111, 111, 120)",
                    fontWeight: "400",
                  }}
                >
                  Última atualização
                </span>
              </TableCell>
              <TableCell>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "rgb(111, 111, 120)",
                    fontWeight: "400",
                  }}
                >
                  Execução programada
                </span>
              </TableCell>
              <TableCell>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "rgb(111, 111, 120)",
                    fontWeight: "400",
                  }}
                >
                  Status
                </span>
              </TableCell>
            </TableRow>
            {activities.map((activity) => (
              <TableRow
                key={activity.workspaceActivityId}
                style={{ height: "70px" }}
              >
                <TableCell>{activity.name}</TableCell>
                <TableCell>
                  {activity.lastExecution
                    ? formatDate(String(activity.lastExecution))
                    : "-"}
                </TableCell>
                <TableCell>
                  {activity.scheduledExecution
                    ? formatDate(String(activity.scheduledExecution))
                    : "-"}
                </TableCell>
                <TableCell>
                  {activity.status === "IDLE" && (
                    <div
                      style={{
                        color: "#191C1A",
                        backgroundColor: "#191C1A14",
                        opacity: "0.8",
                        padding: "0.25rem 0.75rem",
                        borderRadius: "0.75rem",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "16px",
                        width: "fit-content",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <span>Aguardando</span>
                    </div>
                  )}
                  {activity.status === "PENDING" && (
                    <div
                      style={{
                        color: "#EF6C00",
                        backgroundColor: "#EF6C0014",
                        opacity: "0.8",
                        padding: "0.25rem 0.75rem",
                        borderRadius: "0.75rem",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "16px",
                        width: "fit-content",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <span>Pendente</span>
                    </div>
                  )}
                  {activity.status === "SUCCESS" && (
                    <div
                      style={{
                        color: "#2E7D32",
                        backgroundColor: "#2E7D3214",
                        opacity: "0.8",
                        padding: "0.25rem 0.75rem",
                        borderRadius: "0.75rem",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "16px",
                        width: "fit-content",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <span>Executado</span>
                    </div>
                  )}
                  {activity.status === "FAILED" && (
                    <div
                      style={{
                        color: "#a30000",
                        backgroundColor: "#ff7d7d3b",
                        opacity: "0.8",
                        padding: "0.25rem 0.75rem",
                        borderRadius: "0.75rem",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "16px",
                        width: "fit-content",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <span>Falhou</span>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </Table>
        </TableContainer>
      </Box>
    </Modal>
  );
}
